import { SelfSellInModel } from '@onrunning/backstage-models';
import { CrudService } from '../../../services/crud.service';

export class SelfSellInService {
  private readonly crudService: CrudService<SelfSellInModel>;

  constructor() {
    this.crudService = new CrudService<SelfSellInModel>('api/self-sell-in');
  }

  public async getSellIn(accountId: string, season: string): Promise<SelfSellInModel> {
    const params = new URLSearchParams({ accountId, season });
    const result = await this.crudService.get(`?${params.toString()}`);

    return result.model;
  }
}
